import * as utils from './utils';
import * as subscriptionTypes from '../../components/company/subscriptionType';

/**
 * Creates a Higher Order Component that can wrap
 * another components in order to protect access to them
 *
 * @param   {String|Array.<String>}                                         role
 * @param   {String=}                                                       wrapperDisplayName
 * @returns {{authenticatedSelector: (function()), wrapperDisplayName: *}}
 *
 * @see https://github.com/mjrussell/redux-auth-wrapper
 */
export const createSettingsForRole = (role, wrapperDisplayName) => {

    let authenticatedSelector = () => {};
    const defaultWrapperNamePrefix = 'UserIs';

    if (Object.prototype.toString.call(role) === '[object Array]') {
        const roles = role;

        authenticatedSelector = state => {
            return utils.hasAtLeastOneRole(state, roles);
        };

        const roleLabels = roles.map(role => utils.capitalizeFirstLetter(role));

        wrapperDisplayName = wrapperDisplayName || defaultWrapperNamePrefix + roleLabels.join('Or');
    } else {
        authenticatedSelector = state => {
            return utils.hasRole(state, role);
        };

        wrapperDisplayName = wrapperDisplayName || defaultWrapperNamePrefix + utils.capitalizeFirstLetter(role);
    }

    return {
        authenticatedSelector,
        wrapperDisplayName,
    };
};

/**
 * Default access config
 *
 * @type {{authenticatedSelector: (function(*)), authenticatingSelector: (function(*): boolean), wrapperDisplayName: string}}
 */
export const accessDefaults = {
    authenticatedSelector: state => {
        return state.user.id !== undefined;
    },
    authenticatingSelector: state => false,
    wrapperDisplayName: 'UserIsAuthenticated',
};

export const notMaskinstationerMini = {
    authenticatedSelector: state => {
        return state.user.company.subscriptionType !== parseInt(subscriptionTypes.MASKINSTATIONER_MINI);
    },
    wrapperDisplayName: 'isNotMaskinstationerMini'
};

export const notMaskinbladetUser = {
    authenticatedSelector: state => {
        return (state.user.company.portalId !== 4);
    },
    wrapperDisplayName: 'isNotMaskinbladetUser'
};

export const onlyMaskinstationerRegular = {
    authenticatedSelector: state => {
        return state.user.company.subscriptionType === parseInt(subscriptionTypes.MASKINSTATIONER_REGULAR);
    },
    wrapperDisplayName: 'isMaskinstationerRegular'
};

export const onlyMaskinstationer = {
    authenticatedSelector: state => {
        return (state.user.company.subscriptionType === parseInt(subscriptionTypes.MASKINSTATIONER_REGULAR)
            || state.user.company.subscriptionType === parseInt(subscriptionTypes.MASKINSTATIONER_MINI)
        );
    },
    wrapperDisplayName: 'isMaskinstationer'
};


// WEBPACK FOOTER //
// ./web/src/services/access/accessRulesCreator.js